import { COLORS } from '@constants';
import { Card } from 'antd';
import styled, { css } from 'styled-components';

export const StyledCard = styled(Card)`
    & .ant-card-head {
        border-bottom: none;
        min-height: auto;
        padding-top: 24px;
        padding-bottom: 24px;

        ${({ $isHomePage }) =>
            !$isHomePage
                ? css`
                      padding-bottom: 0;
                      border: none;

                      &:after {
                          border-bottom: 1px solid ${COLORS.$gray15Black};
                          padding-top: 24px;
                      }
                  `
                : ''}
    }

    & .ant-card-body {
        height: 243px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
